// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Section "Evaluation de Centralis" : reutilise les classes globales de Profil.css
   (.synthese-besoins-block / -banner / -content, .synthese-cards / -card / -icon
   / -titre / -valeur, .stats-besoins-notice). Ici : ajustements specifiques. */

.evaluations-page .eval-notice {
  margin: 0 0 1.5rem 0;
}

/* Alignement de TOUT le contenu des cartes entre elles :
   - cartes a hauteur egale (flex stretch)
   - icone en haut (taille fixe), zone titre a hauteur uniforme (top-alignee)
   - valeur (etoiles / texte) epinglee en bas -> toutes les valeurs sur la meme ligne. */
.evaluations-page .synthese-cards {
  align-items: stretch;
}

.evaluations-page .synthese-card-titre {
  min-height: 3.4rem;
  display: flex;
  align-items: flex-start;
  justify-content: center;
}

/* Bloc bas de carte (menu + etoiles + note globale), epingle en bas : toutes les valeurs
   des cartes s'alignent sur la meme ligne quelle que soit la hauteur du titre. */
.evaluations-page .eval-card-control {
  margin-top: auto;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.7rem;
}

/* Ligne etoiles + note "(x/5)". */
.eval-card-rating {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.6rem;
}
.evaluations-page .eval-card-note {
  font-size: 1.2rem;
  font-weight: 700;
  color: #6b7280;
  white-space: nowrap;
}

/* Carte Satisfaction (note calculee, pas de menu) : la moyenne de l'utilisateur en heros,
   centree verticalement ; la Note Globale Centralis reste en bas. */
.evaluations-page .eval-card-control--satisfaction {
  margin-top: 0;
  flex: 1 1;
  justify-content: center;
  gap: 1.6rem;
}
/* Heros : etoiles au-dessus, grand chiffre en dessous. */
.evaluations-page .eval-card-rating--lg {
  flex-direction: column;
  gap: 0.7rem;
}
.evaluations-page .eval-card-note--lg {
  font-size: 2.2rem;
  font-weight: 800;
  line-height: 1;
}
/* Etoiles du heros un peu plus grandes (sinon le grand chiffre les ecrase). */
.evaluations-page .eval-card-rating--lg .star-rating-glyph {
  width: 2.6rem;
  height: 2.6rem;
}

/* Note Globale (moyenne agregee de tous les avis Centralis) sous les etoiles. */
.evaluations-page .eval-card-globale {
  display: block;
  margin-top: 0.6rem;
  font-size: 1.15rem;
  font-weight: 600;
  color: #6b7280;
  text-align: center;
}
/* Nombre d'avis : ligne dediee sous la note globale (plus discrete). */
.evaluations-page .eval-card-avis {
  display: block;
  margin-top: 0.15rem;
  font-size: 1rem;
  font-weight: 600;
  color: #9ca3af;
}
.evaluations-page .eval-card--satisfaction .eval-card-globale {
  color: rgba(255, 255, 255, 0.95);
}
/* Carte Satisfaction (fond orange) : "(x/5)" + nombre d'avis lisibles en blanc. */
.evaluations-page .eval-card--satisfaction .eval-card-note {
  color: #ffffff;
}
.evaluations-page .eval-card--satisfaction .eval-card-avis {
  color: rgba(255, 255, 255, 0.8);
}

/* Menu deroulant des paliers (note 1-5) : la selection remplit les etoiles. */
.evaluations-page .eval-card-select {
  width: 100%;
  padding: 0.5rem 0.6rem;
  border: 1px solid #d1d5db;
  border-radius: 0.6rem;
  font-size: 1.2rem;
  font-family: inherit;
  color: #374151;
  background: #fff;
  cursor: pointer;
}
.evaluations-page .eval-card-select:focus {
  outline: none;
  border-color: #f97316;
  box-shadow: 0 0 0 3px rgba(249, 115, 22, 0.1);
}

/* Skeletons de chargement (Note Globale + menu deroulant). */
.evaluations-page .eval-card-globale--skeleton {
  display: block;
  width: 65%;
  height: 1.15rem;
  margin: 0.6rem auto 0;
  border-radius: 4px;
  background: linear-gradient(90deg, #e5e7eb 25%, #f3f4f6 50%, #e5e7eb 75%);
  background-size: 200% 100%;
  animation: eval-card-sk 1.4s ease-in-out infinite;
}
.evaluations-page .eval-card-select--skeleton {
  display: block;
  height: 3.2rem;
  border: none;
  background: linear-gradient(90deg, #e5e7eb 25%, #f3f4f6 50%, #e5e7eb 75%);
  background-size: 200% 100%;
  animation: eval-card-sk 1.4s ease-in-out infinite;
  cursor: default;
}
@keyframes eval-card-sk {
  0% { background-position: -200% 0; }
  100% { background-position: 200% 0; }
}

/* Carte Satisfaction Globale : fond orange, texte + icone + etoiles en blanc. */
.evaluations-page .eval-card--satisfaction {
  background: #f97316;
  border-color: #f97316;
}

.evaluations-page .eval-card--satisfaction .synthese-card-titre {
  color: #fff;
}

/* Icone SVG noire -> blanche. */
.evaluations-page .eval-card--satisfaction .synthese-card-icon {
  filter: brightness(0) invert(1);
}

/* Etoiles en blanc (sinon orange sur orange = invisible). */
.evaluations-page .eval-card--satisfaction .star-rating-glyph path {
  fill: rgba(255, 255, 255, 0.45);
}

.evaluations-page .eval-card--satisfaction .star-rating-glyph.is-filled path,
.evaluations-page .eval-card--satisfaction .star-rating--skeleton .star-rating-glyph path {
  fill: #fff;
}
`, "",{"version":3,"sources":["webpack://./src/composants/EvaluationCentralis/EvaluationCentralis.css"],"names":[],"mappings":"AAAA;;+EAE+E;;AAE/E;EACE,oBAAoB;AACtB;;AAEA;;;wFAGwF;AACxF;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;iFACiF;AACjF;EACE,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;AACb;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;oEACoE;AACpE;EACE,aAAa;EACb,SAAO;EACP,uBAAuB;EACvB,WAAW;AACb;AACA,yDAAyD;AACzD;EACE,sBAAsB;EACtB,WAAW;AACb;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;AACA,8EAA8E;AAC9E;EACE,aAAa;EACb,cAAc;AAChB;;AAEA,gFAAgF;AAChF;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;AACA,uEAAuE;AACvE;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gCAAgC;AAClC;AACA,kFAAkF;AAClF;EACE,cAAc;AAChB;AACA;EACE,+BAA+B;AACjC;;AAEA,8EAA8E;AAC9E;EACE,WAAW;EACX,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,oBAAoB;EACpB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA,6DAA6D;AAC7D;EACE,cAAc;EACd,UAAU;EACV,eAAe;EACf,qBAAqB;EACrB,kBAAkB;EAClB,yEAAyE;EACzE,0BAA0B;EAC1B,iDAAiD;AACnD;AACA;EACE,cAAc;EACd,cAAc;EACd,YAAY;EACZ,yEAAyE;EACzE,0BAA0B;EAC1B,iDAAiD;EACjD,eAAe;AACjB;AACA;EACE,KAAK,4BAA4B,EAAE;EACnC,OAAO,2BAA2B,EAAE;AACtC;;AAEA,gFAAgF;AAChF;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA,gCAAgC;AAChC;EACE,+BAA+B;AACjC;;AAEA,4DAA4D;AAC5D;EACE,+BAA+B;AACjC;;AAEA;;EAEE,UAAU;AACZ","sourcesContent":["/* Section \"Evaluation de Centralis\" : reutilise les classes globales de Profil.css\n   (.synthese-besoins-block / -banner / -content, .synthese-cards / -card / -icon\n   / -titre / -valeur, .stats-besoins-notice). Ici : ajustements specifiques. */\n\n.evaluations-page .eval-notice {\n  margin: 0 0 1.5rem 0;\n}\n\n/* Alignement de TOUT le contenu des cartes entre elles :\n   - cartes a hauteur egale (flex stretch)\n   - icone en haut (taille fixe), zone titre a hauteur uniforme (top-alignee)\n   - valeur (etoiles / texte) epinglee en bas -> toutes les valeurs sur la meme ligne. */\n.evaluations-page .synthese-cards {\n  align-items: stretch;\n}\n\n.evaluations-page .synthese-card-titre {\n  min-height: 3.4rem;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n}\n\n/* Bloc bas de carte (menu + etoiles + note globale), epingle en bas : toutes les valeurs\n   des cartes s'alignent sur la meme ligne quelle que soit la hauteur du titre. */\n.evaluations-page .eval-card-control {\n  margin-top: auto;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.7rem;\n}\n\n/* Ligne etoiles + note \"(x/5)\". */\n.eval-card-rating {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.6rem;\n}\n.evaluations-page .eval-card-note {\n  font-size: 1.2rem;\n  font-weight: 700;\n  color: #6b7280;\n  white-space: nowrap;\n}\n\n/* Carte Satisfaction (note calculee, pas de menu) : la moyenne de l'utilisateur en heros,\n   centree verticalement ; la Note Globale Centralis reste en bas. */\n.evaluations-page .eval-card-control--satisfaction {\n  margin-top: 0;\n  flex: 1;\n  justify-content: center;\n  gap: 1.6rem;\n}\n/* Heros : etoiles au-dessus, grand chiffre en dessous. */\n.evaluations-page .eval-card-rating--lg {\n  flex-direction: column;\n  gap: 0.7rem;\n}\n.evaluations-page .eval-card-note--lg {\n  font-size: 2.2rem;\n  font-weight: 800;\n  line-height: 1;\n}\n/* Etoiles du heros un peu plus grandes (sinon le grand chiffre les ecrase). */\n.evaluations-page .eval-card-rating--lg .star-rating-glyph {\n  width: 2.6rem;\n  height: 2.6rem;\n}\n\n/* Note Globale (moyenne agregee de tous les avis Centralis) sous les etoiles. */\n.evaluations-page .eval-card-globale {\n  display: block;\n  margin-top: 0.6rem;\n  font-size: 1.15rem;\n  font-weight: 600;\n  color: #6b7280;\n  text-align: center;\n}\n/* Nombre d'avis : ligne dediee sous la note globale (plus discrete). */\n.evaluations-page .eval-card-avis {\n  display: block;\n  margin-top: 0.15rem;\n  font-size: 1rem;\n  font-weight: 600;\n  color: #9ca3af;\n}\n.evaluations-page .eval-card--satisfaction .eval-card-globale {\n  color: rgba(255, 255, 255, 0.95);\n}\n/* Carte Satisfaction (fond orange) : \"(x/5)\" + nombre d'avis lisibles en blanc. */\n.evaluations-page .eval-card--satisfaction .eval-card-note {\n  color: #ffffff;\n}\n.evaluations-page .eval-card--satisfaction .eval-card-avis {\n  color: rgba(255, 255, 255, 0.8);\n}\n\n/* Menu deroulant des paliers (note 1-5) : la selection remplit les etoiles. */\n.evaluations-page .eval-card-select {\n  width: 100%;\n  padding: 0.5rem 0.6rem;\n  border: 1px solid #d1d5db;\n  border-radius: 0.6rem;\n  font-size: 1.2rem;\n  font-family: inherit;\n  color: #374151;\n  background: #fff;\n  cursor: pointer;\n}\n.evaluations-page .eval-card-select:focus {\n  outline: none;\n  border-color: #f97316;\n  box-shadow: 0 0 0 3px rgba(249, 115, 22, 0.1);\n}\n\n/* Skeletons de chargement (Note Globale + menu deroulant). */\n.evaluations-page .eval-card-globale--skeleton {\n  display: block;\n  width: 65%;\n  height: 1.15rem;\n  margin: 0.6rem auto 0;\n  border-radius: 4px;\n  background: linear-gradient(90deg, #e5e7eb 25%, #f3f4f6 50%, #e5e7eb 75%);\n  background-size: 200% 100%;\n  animation: eval-card-sk 1.4s ease-in-out infinite;\n}\n.evaluations-page .eval-card-select--skeleton {\n  display: block;\n  height: 3.2rem;\n  border: none;\n  background: linear-gradient(90deg, #e5e7eb 25%, #f3f4f6 50%, #e5e7eb 75%);\n  background-size: 200% 100%;\n  animation: eval-card-sk 1.4s ease-in-out infinite;\n  cursor: default;\n}\n@keyframes eval-card-sk {\n  0% { background-position: -200% 0; }\n  100% { background-position: 200% 0; }\n}\n\n/* Carte Satisfaction Globale : fond orange, texte + icone + etoiles en blanc. */\n.evaluations-page .eval-card--satisfaction {\n  background: #f97316;\n  border-color: #f97316;\n}\n\n.evaluations-page .eval-card--satisfaction .synthese-card-titre {\n  color: #fff;\n}\n\n/* Icone SVG noire -> blanche. */\n.evaluations-page .eval-card--satisfaction .synthese-card-icon {\n  filter: brightness(0) invert(1);\n}\n\n/* Etoiles en blanc (sinon orange sur orange = invisible). */\n.evaluations-page .eval-card--satisfaction .star-rating-glyph path {\n  fill: rgba(255, 255, 255, 0.45);\n}\n\n.evaluations-page .eval-card--satisfaction .star-rating-glyph.is-filled path,\n.evaluations-page .eval-card--satisfaction .star-rating--skeleton .star-rating-glyph path {\n  fill: #fff;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
